import React, { useEffect, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { Bounce, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";

export default function CheckoutUpgradeForm({ plan, clientData,plan_amount }) {
  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [initialStatus, setInitialStatus] = useState(clientData?.payment_status || null);

  const optionToast = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "colored",
    transition: Bounce,
  };

  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };

  const saveDataTolocalStorage = (key, data) => {
    try {
      const serializedData = JSON.stringify(data);
      localStorage.setItem(key, serializedData);
    } catch (error) {
      console.error("Error saving data to localStorage:", error);
    }
  };

  const storedUserPreferences = getDataFromlocalStorage("userData");

  const savePaymentToBackend = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/upgrade-dealer",
        {
          user_id: storedUserPreferences?.id,
          amount: clientData?.payable_amount / 100 > 0 ? plan_amount : parseFloat(plan?.price) + plan?.vat,
          car_limit: plan?.carLimit,
          type: plan?.period + "ly",
          plan_code: plan?.code,
          pay_id: clientData?.payment_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

        if (response?.data?.status) {
          toast.success("Info saved successfully!", optionToast);
          const existingData = JSON.parse(localStorage.getItem("userData")) || {};
          const updatedData = { ...existingData, ...response?.data?.user };
          if (existingData.token) updatedData.token = existingData.token;
          saveDataTolocalStorage("userData", updatedData);

        setTimeout(() => {
          navigate("/dealer/success", {
            state: {
              payment_id: clientData?.payment_id,
              amount: clientData?.payable_amount / 100 > 0 ? plan_amount : parseFloat(plan?.price) + plan?.vat,
            },
          });
        }, 2000);
      } else {
        toast.error("Saved payment but failed to update backend!", optionToast);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to save payment info.", optionToast);
    }
    setIsLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    if (initialStatus === "succeeded") {
      toast.info("Payment already completed.", optionToast);
      return;
    }

    setIsLoading(true);

    try {
      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          payment_method_data: {
            billing_details: {
              name: storedUserPreferences?.first_name,
              email: storedUserPreferences?.email,
              phone: storedUserPreferences?.phone,
              address: {
                line1: storedUserPreferences?.address_first,
                city: storedUserPreferences?.city,
                postal_code: storedUserPreferences?.postcode,
                country: storedUserPreferences?.country,
              },
            },
          },
        },
        redirect: "if_required",
      });

      if (error) {
        setMessage(error.message || "An unexpected error occurred.");
        toast.error(error.message || "Payment failed.", optionToast);
        setIsLoading(false);
        return;
      }

      if (paymentIntent?.status === "succeeded") {
        setMessage("Payment succeeded!");
        clientData.payment_id = paymentIntent.id;
        clientData.payable_amount = paymentIntent.amount;
        clientData.status = paymentIntent.status;
        await savePaymentToBackend();
      } else {
        toast.warn("Payment is still processing. Please wait.", optionToast);
      }
    } catch (err) {
      console.error(err);
      toast.error("Error while confirming payment.", optionToast);
    }

    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: "tabs",
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      {initialStatus === "succeeded" ? (
        <>
          <div className="alert alert-success mb-3">
            Payment already completed. Please click below to save info.
          </div>
          <button
            type="button"
            onClick={savePaymentToBackend}
            disabled={isLoading}
            className="btn btn-success"
          >
            {isLoading ? "Saving..." : "Save Info"}
          </button>
        </>
      ) : (
        <>
          <PaymentElement id="payment-element" options={paymentElementOptions} />
          <button disabled={isLoading || !stripe || !elements} id="submit">
            <span id="button-text">
              {isLoading ? <div className="spinner" id="spinner"></div> : "Pay now " +"£"+ plan_amount} 
            </span>
          </button>
        </>
      )}

      {message && <div id="payment-message" className="mt-3">{message}</div>}
    </form>
  );
}
